import React, { useState } from 'react';
import {
  Button,
  Form,
  Grid,
  Header,
  Segment,
  Message,
} from 'semantic-ui-react';
import { useLocation, useHistory } from 'react-router-dom';
import { resetB2CPassword } from '../services/AuthApi';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const PasswordResetForm = (props) => {
  const [password, setPassword] = useState('');

  const [formError, setFormError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const history = useHistory();

  let query = useQuery();
  let email = query.get('email');
  let oneTimePassword = query.get('oneTimePassword');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormError(false);
    setErrorMessage('');
    setIsLoading(true);

    if (!oneTimePassword || !email) {
      setErrorMessage('Invalid reset link. Please request a new password reset email.');
      setFormError(true);
      setIsLoading(false);
      return;
    }

    if (!password || password.length < 6) {
      setErrorMessage('Password must be at least 6 characters long');
      setFormError(true);
      setIsLoading(false);
      return;
    }
    try{
      await resetB2CPassword(email, oneTimePassword, password);
      setSuccess(true);
      // Redirect to login after 3 seconds
      setTimeout(() => {
        history.push('/login');
      }, 3000);
    } catch (error) {
      console.error('Password reset failed:', error);
      setErrorMessage(error.message || 'Failed to reset password. Please try again.');
      setFormError(true);
    } finally {
      setIsLoading(false);
    }
  };


  if (success) {
    return (
      <div
        style={{
          backgroundImage:
            'url("/images/shutterstock_461838712.jpg")',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      >
        <Grid
          textAlign="center"
          style={{
            height: '100vh',
            margin: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
          }}
          verticalAlign="middle"
        >
          <Grid.Column
            style={{
              maxWidth: 450,
              backgroundColor: '#fff',
              padding: '3em',
            }}
          >
            <Header as="h2" textAlign="center">
              Password Reset Success!
              <Header.Subheader>
                Please visit the login page and re-login with your new
                password.
              </Header.Subheader>
            </Header>
          </Grid.Column>
        </Grid>
      </div>
    );
  } else {
    return (
      <div
        style={{
          backgroundImage:
            'url("/images/shutterstock_461838712.jpg")',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      >
        <Grid
          textAlign="center"
          style={{
            height: '100vh',
            margin: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
          }}
          verticalAlign="middle"
        >
          <Grid.Column
            style={{
              maxWidth: 450,
              backgroundColor: '#fff',
              padding: '3em',
            }}
          >
            <Header as="h2" textAlign="center">
              <Header.Content>Reset Password</Header.Content>
            </Header>
            <Form size="large" error={formError} onSubmit={handleSubmit}>
              <Segment style={{ border: '0', boxShadow: '0 0 0 0' }}>
                {formError && (
                  <Message
                    error
                    header="Error"
                    content={errorMessage}
                  />
                )}
                <Form.Input
                  autoComplete="new-password"
                  fluid
                  icon="lock"
                  iconPosition="left"
                  placeholder="New Password"
                  type="password"
                  value={password}
                  onChange={(event) =>
                    setPassword(event.target.value.replace(/\s/g, ''))
                  }
                />
                <Button
                  type="submit"
                  color="green"
                  fluid
                  size="large"
                  loading={isLoading}
                  disabled={isLoading}
                >
                  {isLoading ? 'Resetting Password...' : 'Change Password'}
                </Button>
              </Segment>
            </Form>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
};

export default PasswordResetForm;
